import gql from "graphql-tag"

const LOGOUT_MUTATION = gql`
  mutation logout {
    logout {
      success
    }
  }
`

export default LOGOUT_MUTATION
